module.exports = __webpack_public_path__ + "images/frontpage_stars@2x.png?67139704";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_stars@2x.png
// module id = 664
// module chunks = 7